import React from 'react';

export default {
  width: 26,
  height: 26,
  content: (
    <path d="M13 26C5.82 26 0 20.18 0 13S5.82 0 13 0s13 5.82 13 13-5.82 13-13 13zm4.642-16.707l-5.482 5.482-3.453-3.453-1.414 1.414 4.867 4.867 6.896-6.896-1.414-1.414z" />
  )
};
